import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { type } from '@app/util/util';

import {
  HotelDetailPayload, HotelDetailDeepLinkPayload
} from '@hotels/hotel-detail/entities/hotel-detail.payload';
import { HotelDetailResponse } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import {
  HotelByCodePackagePayload, HotelDetailPackagePayload, HotelDetailPackageResponse
} from '@packages/packages-result/entities/hotel-detail';

export const fetchHotelDetailAction = createAction(type('[Hotels/API] Fetch hotel detail'),
  props<{ payload: HotelDetailPayload }>());
export const fetchHotelDetailSuccessAction = createAction(type('[Hotels/API] Fetch hotel detail success'),
  props<{ hotel: HotelDetailResponse }>());
export const fetchHotelDetailDeeplinkAction = createAction(type('[Hotels/API] Fetch hotel detail deeplink'),
  props<{ payload: HotelDetailDeepLinkPayload, isByhours?: boolean }>());
export const fetchHotelDetailDeeplinkSuccessAction = createAction(type('[Hotels/API] Fetch hotel detail deeplink success'),
  props<{ payload: HotelDetailPayload }>());
export const fetchHotelDetailDeeplinkErrorAction = createAction(type('[Hotels/API] Fetch hotel detail deeplink error'),
  props<{ payload: HttpErrorResponse }>());
export const resetHotelDetailAction = createAction(type('[Hotels/API] Reset hotel detail'));
export const fetchHotelDetailSearchedAction = createAction(type('[Hotels/DATA] Fetch hotel detail searched'),
  props<{ hotel: HotelSearched }>());
export const fetchHotelDetailPackageAction = createAction(type('[HotelsDetailPackage/API] Fetch hotel detail package'),
  props<{ payload: HotelDetailPackagePayload }>());
export const fetchHotelDetailPackageSuccessAction = createAction(
  type('[HotelsDetailPackage/API] Fetch hotel detail success packages'),
  props<{ hotel: HotelDetailPackageResponse }>());
export const fetchHotelDetailByCodePackageAction = createAction(
  type('[HotelsDetailPackage/API] Fetch hotel detail by code package'),
  props<{ payload: HotelByCodePackagePayload }>());
export const fetchHotelDetailByCodePackageSuccessAction = createAction(
  type('[HotelsDetailPackage/API] Fetch hotel detail by code success packages'),
  props<{ hotel: HotelDetailPayload }>());

export const navigateByHistoryHotelDetailSuccessAction = createAction(
  type('[HotelsDetail/API] Error in hotel hetail, go last route success'));

export const setPackageBaseUrlResultInHotelDetailAction = createAction(
  type('[HotelsDetail/UI] Set packages url base for results'),
  props<{ url: string }>()
);

export const setHotelResultUrlInHotelDetailAction = createAction(
  type('[HotelsDetail/UI] Set hotel results url'),
  props<{ url: string }>()
);

export const resetTooltipsAction = createAction(
  type('[Hotels/API] Reset tooltips'),
  props<{ payload: boolean}>()
);

